import Config from '@/config'
import type { Interaction } from '@/lib/analytics/index.types'
import { logger } from '@/lib/logger'
import type { ApisauceInstance } from 'apisauce'
import { create } from 'apisauce'
import { authRequestInterceptor } from './interceptors/auth'

export class IntelApi {
	_apiConfig: ApisauceInstance

	constructor() {
		this._apiConfig = create({
			baseURL: Config.INTEL_API_URL_BASE,
			timeout: 10000,
		})

		this._apiConfig.axiosInstance.interceptors.request.use(authRequestInterceptor)
	}

	sendInteraction(interaction: Interaction) {
		this._apiConfig
			.post('/interactions', interaction)
			.catch((error) =>
				logger.error(new Error('failed_to_send_interaction', { cause: error }))
			)
	}
}

export const intelApi = new IntelApi()
